export const VARIATION_TYPES = [
    {value: 'a color', label: 'Color'},
    {value: 'a size', label: 'Size'},
    {value: 'a shape', label: 'Shape'},
    {value: 'a letter', label: 'Letter'},
    {value: 'a texture', label: 'Texture'},
    {value: 'an animal', label: 'Animal'},
    {value: 'a pattern', label: 'Pattern'},
    {value: 'a frame color', label: 'Frame Color'},
    {value: 'a plant', label: 'Plant'},
    {value: 'a print', label: 'Print'},
    {value: 'an arrangement', label: 'Arrangement'},
    {value: 'a position', label: 'Position'},
    {value: 'an option', label: 'Option'},
    {value: 'a width', label: 'Width'},
    {value: 'a height', label: 'Height'},
    {value: 'a group', label: 'Group'},
];